import { pickBy } from "src/utils/miniLodash";

export const omitUndefinedProps = <T extends Record<string, unknown>>(obj: T) =>
  pickBy(obj, (value) => value !== undefined);
